import { common } from './common';
import { auth } from './auth';
import { components } from './components';
import { pages } from './pages';

export const es = {
  common,
  auth,
  components,
  pages,
};
